export class UpdateGraphInput {
    'title';
    'chartType';
    'sqlQuery';
    'columnMapping';
    'layout';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "chartType",
            "baseName": "chartType",
            "type": "UpdateGraphInputChartTypeEnum",
            "format": ""
        },
        {
            "name": "sqlQuery",
            "baseName": "sqlQuery",
            "type": "string",
            "format": ""
        },
        {
            "name": "columnMapping",
            "baseName": "columnMapping",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "layout",
            "baseName": "layout",
            "type": "DashboardGraphLayout",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateGraphInput.attributeTypeMap;
    }
    constructor() {
    }
}
export var UpdateGraphInputChartTypeEnum;
(function (UpdateGraphInputChartTypeEnum) {
    UpdateGraphInputChartTypeEnum["Bar"] = "BAR";
    UpdateGraphInputChartTypeEnum["Line"] = "LINE";
    UpdateGraphInputChartTypeEnum["Pie"] = "PIE";
    UpdateGraphInputChartTypeEnum["Area"] = "AREA";
    UpdateGraphInputChartTypeEnum["Scatter"] = "SCATTER";
    UpdateGraphInputChartTypeEnum["Donut"] = "DONUT";
    UpdateGraphInputChartTypeEnum["Table"] = "TABLE";
})(UpdateGraphInputChartTypeEnum || (UpdateGraphInputChartTypeEnum = {}));
